import * as React from 'react';
import parse, {HTMLReactParserOptions} from "html-react-parser";
import { Element } from "html-react-parser"
import { IGalleryItemDetails, ImageHtmlTags } from "modules/gallery";
import InlineGallery from "modules/common/components/inlineGallery";

//This function takes a html body and checks for inline-gallery objects that have been inserted. 
//If we catch any, we directly replace them with their react equivalent to restore functionality.
export const generateBody = (htmlBody: string, verticalParentId?: string) => {
    const options: HTMLReactParserOptions = {
        replace(domNode: Element) {
            const itemId:string = domNode?.attribs?.id ?? "";
            if(itemId.includes("inline-gallery")) {
                let galleryDetails: IGalleryItemDetails[] = [];

                const wrapper = domNode.children.find(c => (c as Element)?.attribs?.id === 'inline-container') as Element;
                if(!wrapper) {
                    return null;
                }

                const imageContainer = wrapper.children.find(c => (c as Element)?.attribs?.id === 'inline-wrapper') as Element;
                if(!imageContainer) {
                    return null;
                }
                
                const images = imageContainer.children;

                for(let index in images) { 
                    let element = images[index] as Element;
                    let imageAttribs = element.attribs;
                    let imageSrc = imageAttribs[ImageHtmlTags.Source];
                    let imageId = imageAttribs[ImageHtmlTags.OspreyId];
                    let caption = imageAttribs[ImageHtmlTags.ImageCaption];

                    let imageDetails: IGalleryItemDetails = {ospreyId: imageId, fileUrl: imageSrc, caption: caption};
                    galleryDetails = galleryDetails.concat(imageDetails);
                }

                return <InlineGallery selectedImageDetails={galleryDetails} verticalParentId={verticalParentId} showInteractables />
            }
        }
    };

    if(htmlBody) {
        let replacedAndParsedBody = parse(htmlBody, options);
        return replacedAndParsedBody;
    }
    else {
        return "";
    }
}